// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"bcec521a","117":"5c73f14d","209":"e1f55257","478":"e9ff0477","625":"b60122b8","745":"b5c83463","922":"a9748d02","964":"763e6f1c"}[chunkId] + ".chunk.js";
};